import React from 'react';
import styled from "styled-components";
import Link from "next/link";
import Carousel, {CarouselItem} from '@molecules/swiper/carousel';
import Icon from "@atoms/icon";
import ArrowLeftIcon from '@icons/arrow-left.svg';

const VillaTypesSliderWithText = ({urlPrefix,city_name}) => {
    const breakpoints = {
        1024: {
            slidesPerView: 3,
        },
        768: {
            slidesPerView: 2.4,
        },
        320: {
            slidesPerView: 1.3,
        }
    };

    const villaTypes = [
        {title: 'جنگلی', img: 'jungle'},
        {title: 'ساحلی', img: 'beach'},
        {title: 'شهرکی', img: 'town'},
    ];

    return (
        <Carousel breakpoints={breakpoints} navigation_show={false}>
            {
                villaTypes.map((villaType, key) =>
                    <CarouselItem key={key}>
                        <Link href="/properties" as={urlPrefix + '-' + villaType.title}>
                            <a>
                                <Card className={(villaType.img) + " rounded-16 p-24 p-md-32 d-flex flex-column align-items-center justify-content-end "}>
                                    <h2 className="h1 w-100 text-white d-flex align-items-end justify-content-between">
                                        <span className="">خرید ویلای {villaType.title} <br className="d-none d-md-block"/> در {city_name} </span>

                                        <span className="banner-icon bg-white rounded-circle mr-16 mt-16 d-inline-flex align-items-center justify-content-center">
                                            <Icon className=""><ArrowLeftIcon/></Icon>
                                        </span>
                                    </h2>
                                </Card>
                            </a>
                        </Link>
                    </CarouselItem>
                )
            }
        </Carousel>
    );
};

export default React.memo(VillaTypesSliderWithText);

// styles

const Card = styled.section`
    background-color: ${props => props.theme.gray100};
    background-repeat: no-repeat;
    background-size: cover;
    background-position: 50%;
    min-height: 280px;
    
    .banner-icon {
        position: relative;
        top: -8px;
        width: 32px;
        min-width: 32px;
        max-width: 32px;
        height: 32px;
    }
    
    &.jungle {
        background-image: url(/_img/landings/jungle-2.jpg?v=1);
    }
    
    &.beach {
        background-image: url(/_img/landings/beach-2.jpg?v=1);
    }
    
    &.town {
        background-image: url(/_img/landings/town-2.jpg?v=1);
    }
    
    .icons {
        width: 16px;
        height: 16px;
        vertical-align: middle;
        
        svg {
            g {
                stroke-width: 2;
            }
        }
    }
`;